import { Trans, useTranslation } from 'react-i18next';
import type { ServiceModalData } from '@/api/service/types';
import { formatFare } from '@/lib/common';
import { RentType } from '@/lib/constants';
import FareDescriptionItem from './FareDescriptionItem';

type Props = {
  service: ServiceModalData;
};

export default function ServiceDescriptionItem({ service }: Props) {
  const { t } = useTranslation();
  return (
    <article
      data-test-id="servicesPriceItemDesc"
      className="flex flex-col items-center bg-transparent"
    >
      <h2 className="text-neutral-90 text-title32 mb-3 px-4 text-center font-bold">
        {service?.vehicle_model?.name}
      </h2>
      <div className="desktop:space-x-8 desktop:space-y-0 flex flex-row space-x-4">
        {service?.service_type === RentType.BIKE && (
          <FareDescriptionItem
            item={service?.base_price_by_type?.hourly_fare}
            type="hour"
          />
        )}

        <FareDescriptionItem
          item={service?.base_price_by_type?.daily_fare}
          type="day"
          rentType={service?.service_type}
        />
      </div>

      {service?.service_type === RentType.CAR && (
        <div>
          <h2 className=" text-neutral-90 text-title18 mt-10 mb-3 pt-1 text-center font-bold">
            {t('home:noted:title')}
          </h2>
          <ul className="text-body12 desktop:text-body16 destop:px-0 mobile:text-center list-disc px-6">
            <li>
              <Trans
                i18nKey="home:noted:free_for_first_distance"
                values={{
                  number:
                    service?.base_price_by_type?.daily_fare
                      ?.allow_distance_in_kilometer_per_renting_unit,
                }}
              />
            </li>
            <li>
              <Trans
                i18nKey="home:noted:excess_mileage_charges"
                values={{
                  amount: formatFare(
                    service?.fee_configs?.excess_distance_fee_per_kilometer
                  ),
                }}
              />
            </li>
          </ul>
        </div>
      )}
    </article>
  );
}
